<template>
    <div v-if="params && params.isActive">
        <ModalDefault @close="close()" :loading="loading">
            <template slot="main">
                <div class="d-flex justify-content-center container flex-column">
                    <p class="modal-title">{{ zone.name }} - {{ currentBrand.name }}</p>

                    <div class="form-group row">
                        <DefaultTextInputBloc
                            :label="$t('zone.name')"
                            :required="true"
                            v-model.trim="zone.name"
                            :max-length="99"
                        ></DefaultTextInputBloc>
                    </div>
                    <br />
                    <div class="form-group row">
                        <DefaultTextInputBloc
                            :label="$t('zone.abbreviation')"
                            :required="false"
                            v-model="zone.abbreviation"
                            :max-length="10"
                        ></DefaultTextInputBloc>
                    </div>
                    <br />
                    <div class="form-group row">
                        <DefaultTextareaInputBloc
                            :label="$t('zone.description')"
                            :required="false"
                            v-model="zone.description"
                            :max-length="1000"
                        ></DefaultTextareaInputBloc>
                    </div>
                    <br />
                    <div class="form-group row">
                        <DefaultTextareaInputBloc
                            :label="$t('zone.refClient')"
                            :required="false"
                            v-model.trim="zone.refClient"
                            :max-length="100"
                        ></DefaultTextareaInputBloc>
                    </div>

                    <div class="d-flex justify-content-end mt-4">
                        <ClientColorButton
                            :inactiveColor="!isFormValidated"
                            :background-color="currentBrand.linksColor"
                            @click="saveEditZone()"
                            class="mr-3"
                            :disabled="!isFormValidated"
                            >{{ $t("common.save") }}</ClientColorButton
                        >
                        <ClientColorButton :inactiveColor="true" @click.prevent="close()">{{ $t("actions.cancel") }}</ClientColorButton>
                    </div>
                </div>
            </template>
        </ModalDefault>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import cacheService from "@/services/cache";
import ModalTheme from "@/components/ui/ModalTheme";
import TextInputBloc from "@/components/ui/Form/TextInputBloc";
import TextareaInputBloc from "@/components/ui/Form/TextareaInputBloc";
import TryLoad from "@/mixins/TryLoadMixin";
import zoneService from "@/services/zone";
import ModalDefault from "@/components/ui/ModalDefault";
import DefaultTextareaInputBloc from "@/components/ui/Form/DefaultTextareaInputBloc";
import DefaultTextInputBloc from "@/components/ui/Form/DefaultTextInputBloc";
import { removeNbsp } from "../../../utils/string";

export default {
    data() {
        return {
            zone: {},
            loading: false,
            currentBrand: null
        };
    },
    components: {
        DefaultTextInputBloc,
        DefaultTextareaInputBloc,
        ModalDefault,
        ModalTheme,
        TextInputBloc,
        TextareaInputBloc
    },
    props: {
        params: {
            type: Object,
            required: true
        }
    },
    watch: {},
    mixins: [TryLoad],
    mounted() {},
    methods: {
        close() {
            this.params.isActive = false;
        },
        saveEditZone() {
            let updateZone = {
                name: removeNbsp(this.zone.name),
                description: this.zone.description || "",
                abbreviation: this.zone.abbreviation,
                refClient: removeNbsp(this.zone.refClient)
            };
            try {
                this.tryLoad(() => zoneService.update(this.zone.id, updateZone))
                    .then(() => {
                        this.dialogSuccess("success");
                        this.$emit("success");
                        this.close();
                    })
                    .catch(() => this.dialogError("error"));
            } catch (e) {
                this.dialogError("error");
            }
        }
    },
    computed: {
        ...mapGetters({
            getZone: "items/getZone"
        }),
        isFormValidated() {
            return this.zone.name;
        }
    },
    async created() {
        this.loading = true;
        this.zone = Object.assign({}, this.getZone);
        this.currentBrand = cacheService.getBrands().find(b => b.id === cacheService.getCurrentBrandId());
        this.loading = false;
    }
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// EditZone.vue?259dd2d6